<div class="container-column section">
    <section>Submittals</section>
</div>
<div class="card-container card" style="overflow-y: auto;">
    <form [formGroup]="form" style="display: flex;">
        <table style="margin-bottom: 5px;margin-right: 10px;">
            <tr>
                <td>Project:</td>
                <td>
                    <kendo-dropdownlist class="dropdown" [data]="filteredProjects" textField="projectname"
                        valueField="projectId" [style.width.px]="400" formControlName="project" [filterable]="true"
                        (filterChange)="onProjectFilter($event)" (close)="onDropdownClose($event)"
                        [style.height.px]="30" [loading]="loading2">
                    </kendo-dropdownlist>
                </td>
                <td>
                    <div style="margin-top: 3px; margin-left: 10px;">Status:</div>
                </td>
                <td><kendo-multiselect #multiselect class="dropdown" [checkboxes]="true" [autoClose]="false"
                        [data]="statuses" [(ngModel)]="statusArr" [style.width.px]="400" [style.height.px]="30"
                        [ngModelOptions]="{standalone: true}" (valueChange)="onValueChange($event)"></kendo-multiselect>

                </td>
            </tr>
            <tr>
                <td>Order No.:</td>
                <td>
                    <div kendoTooltip [title]="roleDescription"><kendo-dropdownlist class="dropdown"
                            [data]="filteredPortalObjects" textField="name" valueField="id"
                            formControlName="purchaseOrder" [style.width.px]="400" [style.height.px]="30"
                            [defaultItem]="defaultOrderItem" [filterable]="true" (filterChange)="onOrderFilter($event)"
                            [loading]="loading1" (selectionChange)="selectionChange($event)"
                            (valueChange)="getSubmittals()">
                        </kendo-dropdownlist></div>
                </td>
            </tr>
            <tr>
                <td>Description:</td>
                <td> <kendo-textbox class="dropdown" formControlName="description" [style.width.px]="400"
                        [style.height.px]="30" [readonly]="true">
                    </kendo-textbox></td>

                <td>
                    <div style="margin-left: 10px;">Company:</div>
                </td>
                <td> <kendo-textbox class="dropdown" formControlName="companyname" [style.width.px]="400"
                        [style.height.px]="30" [readonly]="true">
                    </kendo-textbox></td>
            </tr>
        </table>
    </form>
    <kendo-splitter orientation="vertical" style="height:83%">
        <kendo-splitter-pane [size]="'40%'">
            <kendo-grid #submittalsGrid [className]="'upload-grid'" [kendoGridBinding]="submittals" kendoGridSelectBy="uploadId"
                [(selectedKeys)]="selection1" [selectable]="{ mode: 'single'}" [sortable]="true" [reorderable]="true"
                [resizable]="true" [columnMenu]="{ filter: true }" [style.height.%]="100" scrollable="virtual"
                (cellClick)="cellClick($event)" [loading]="loading3 || isExporting">
                <ng-template kendoGridToolbarTemplate>
                    <button type="button" kendoButton class="allbuttons" [svgIcon]="svgIcon[1]"
                        (click)="exportSubmittals()" [disabled]="isExporting"
                        title="Export submittals - with applied filters if any (Order & Status), otherwise all data">
                        {{ isExporting ? 'Exporting...' : 'Export' }}
                    </button>
                </ng-template>
                <kendo-grid-column field="uploadId" title="Upload ID" [width]="110"></kendo-grid-column>
                <kendo-grid-column field="objectName" title="Order No." [width]="135"></kendo-grid-column>
                <kendo-grid-column field="objectDescription" title="Order Description"
                    [width]="165"></kendo-grid-column>
                <kendo-grid-column field="company" title="Company" [width]="115"></kendo-grid-column>
                <kendo-grid-column field="status" title="Status" [width]="185">
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <span [style.backgroundColor]="backgroundColorStatus(dataItem.status)" class="whole-cell"
                            [style.border]="getBorder(dataItem.status)">
                            {{dataItem.status}}
                        </span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="uploadDate" title="Submittal Date" [width]="140"
                    format="dd-MMM-yyyy"></kendo-grid-column>
                <!--<kendo-grid-column field="uploadedBy" title="Submitted By" [width]="135"></kendo-grid-column>-->
                <!--<kendo-grid-column field="ackDate" title="Acknowledged Date" [width]="150"
                    format="dd-MMM-yyyy"></kendo-grid-column>
                <kendo-grid-column field="ackBy" title="Acknowledged By" [width]="173"></kendo-grid-column>
                <kendo-grid-column field="procBy" title="Processed By" [width]="125"></kendo-grid-column>
                <kendo-grid-column field="rejBy" title="Rejected By" [width]="125"></kendo-grid-column>-->
                <kendo-grid-column field="fileCount" title="File Count" [width]="110"></kendo-grid-column>
                <!--<kendo-grid-column field="transmittal" title="Transmittal" [width]="125"></kendo-grid-column>
                <kendo-grid-column field="remarks" title="Remarks" [width]="115"></kendo-grid-column>-->
                <kendo-grid-column [width]="110" title="Properties">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <button kendoButton title="Submittal Properties" class="allbuttons"
                            (click)="openPropertiesPopup(dataItem)" [svgIcon]="svgIcon[7]"
                            [disabled]="!(dataItem.accessType === 'PROCESS' || dataItem.accessType === 'VIEW' || isAdmin)">
                        </button>
                    </ng-template>
                </kendo-grid-column>


                <ng-template kendoGridNoRecordsTemplate>
                    <div style="height: 313px;background-color: rgb(215 212 212 / 20%);">
                        <kendo-svgicon [icon]="svgIcon[0]" size="xxxlarge"></kendo-svgicon>
                        <p>There is no data to display here.
                        </p>
                    </div>
                </ng-template>
                <!-- Grid Excel export no longer used - file comes from the backend
                <kendo-grid-excel [fileName]="getFileName()"></kendo-grid-excel>
                -->
            </kendo-grid>
        </kendo-splitter-pane>
        <kendo-splitter-pane style="height: 100% ">
            <div style="display: flex;;">
                <h3>Selected Upload ID: {{selectedUpload == -1 ? '' : selectedUpload}}</h3>
            </div>
            <kendo-grid #filegrid [className]="'upload-grid'" [kendoGridBinding]="fileData" [rowClass]="rowCallback"
                (cellClick)="onRowClick($event)" kendoGridSelectBy="file_id" [(selectedKeys)]="selection2"
                [selectable]="{ mode: 'multiple'}" [sortable]="true" [reorderable]="true" [resizable]="true"
                [columnMenu]="{ filter: true }" [loading]="loading4">
                <ng-template kendoGridToolbarTemplate>
                    <kendo-grid-spacer></kendo-grid-spacer>
                    <button kendoButton class="allbuttons"
                        *ngIf="!disableResetAck()"
                        (click)="resetAcknowledge()" [svgIcon]="svgIcon[5]">
                        Reset Status
                    </button>
                    <button kendoButton class="allbuttons"
                        [disabled] = "disableAckUpload()"
                        (click)="acknowledge()" [svgIcon]="svgIcon[5]">
                        <!-- [disabled]="fileData.length == 0 || status[1] || checkAck() || accessType == 'VIEW' || accessType =='UPLOAD'" -->
                        Acknowledge Upload
                    </button>
                    <button kendoButton class="allbuttons"
                        [ngClass]="{'disable': disableMarkAsProcessed()}"
                        (click)="getProcessed()" [svgIcon]="svgIcon[4]">
                        <!-- [disabled]="fileData.length == 0 || status[0] || checkProcessed() || processed || accessType == 'VIEW' || accessType =='UPLOAD'" -->
                        Mark as Processed
                    </button>
                    <button kendoButton class="allbuttons" [ngClass]="{'disable': downloadCondition()}"
                        (click)="downloadAllFiles()" [svgIcon]="svgIcon[3]">
                        All
                    </button>
                </ng-template>


                <kendo-grid-column title="File Type" [width]="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <kendo-svg-icon class="document-grid-icon iconFontSize" [icon]="getIcon(dataItem.filename).icon"
                            [ngStyle]="getIcon(dataItem.filename).style" size="medium">
                        </kendo-svg-icon>
                    </ng-template>
                </kendo-grid-column>

                <!--<kendo-grid-column title="Type" [width]="50">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span [ngSwitch]="getFileType(dataItem.filename)">
                        <kendo-icon *ngSwitchCase="'pdf'" name="file-pdf"></kendo-icon>
                        <kendo-icon *ngSwitchCase="'excel'" name="file-excel"></kendo-icon>
                        <kendo-icon *ngSwitchCase="'image'" name="image"></kendo-icon>
                        <kendo-icon *ngSwitchCase="'text'" name="file"></kendo-icon> 
                        <kendo-icon *ngSwitchDefault name="file"></kendo-icon>
                        </span>
                    </ng-template>
                </kendo-grid-column>-->

                <!--<kendo-grid-column field="file_id" title="File ID" [width]="70"></kendo-grid-column>-->
                <kendo-grid-column field="filename" title="Filename" [width]="200"></kendo-grid-column>
                <kendo-grid-column field="filesize_to_display" title="Filesize" [width]="100"></kendo-grid-column>
                <!-- <kendo-grid-column field="upload_date" title="File Upload Date" [width]="130">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.upload_date | date:'dd-MMM-yyyy' }}
                    </ng-template>
                </kendo-grid-column> -->
                <!--<kendo-grid-column field="uploaded_by" title="Uploaded By" [width]="120"></kendo-grid-column>-->
                <!--  <kendo-grid-column field="remarks" title="Remarks" [width]="130"></kendo-grid-column>
                <kendo-grid-column field="acknowledged" title="Acknowledged By" [width]="165"></kendo-grid-column> -->
                <kendo-grid-column title="Handled By" [width]="170">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.processed?.split(' by ')[1]}}
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column title="Rejected By" [width]="170">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.rejected?.split(' by ')[1]}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Download & Handle in iDocs" [width]="210">
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <span [ngClass]="{'disable': downloadFlag}">
                            <button kendoButton class="allbuttons" [ngClass]="{'disable': downloadCondition(dataItem)}"
                                (click)="downloadAllFiles(dataItem)" style="margin-right: 3px" title="Download File"
                                [svgIcon]="svgIcon[3]">
                            </button>
                        </span>
                        <button kendoButton
                            style="margin-left: 5px;margin-right: 80px;background-color: green !important; color: white !important;"
                            class="allbuttons" title="Process File" [ngClass]="{'disable': disableProcessed(dataItem)}"
                            (click)="processFile(dataItem.file_id)" [svgIcon]="svgIcon[4]"></button>

                        <button kendoButton
                            style="margin-left: 5px;margin-right: 3.5px;background-color: red !important; color: white !important;"
                            class="allbuttons reject-button" title="Reject File"
                            [ngClass]="{'disable': disableRejected(dataItem)}"
                            (click)="openRejectDialog(dataItem.file_id)" icon="close">
                        </button>

                        <button kendoButton style="margin-left: 5px;" class="allbuttons" title="Reset"
                            [ngClass]="{'disable': disableReset(dataItem)}" (click)="resetFileStatus(dataItem.file_id)"
                            icon="refresh">
                        </button>

                        <!-- [disabled]="dataItem.processed || !dataItem.acknowledged" -->
                    </ng-template>
                </kendo-grid-column>
                <!--<kendo-grid-column field="rejectedRemarks" title="Rejection Remarks" [width]="140"></kendo-grid-column>-->
                
                <kendo-grid-column [width]="110" title="Properties">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <button kendoButton title="File Properties" class="allbuttons"
                            (click)="openFilePropertiesPopup(dataItem)" [svgIcon]="svgIcon[7]"
                            [disabled]="!(accessType === 'PROCESS' || accessType === 'VIEW' || isAdmin)">
                        </button>
                    </ng-template>
                </kendo-grid-column>
                <ng-template kendoGridNoRecordsTemplate>
                    <div style="background-color: rgb(215 212 212 / 20%);">

                        <kendo-svgicon [icon]="svgIcon[0]" size="xxxlarge"></kendo-svgicon>

                        <p>There is no data to display here.

                        </p>
                        <p>Make sure you select an upload in the grid above.</p>
                    </div>
                </ng-template>
            </kendo-grid>
        </kendo-splitter-pane>

    </kendo-splitter>
    <div>
        <kendo-window #progresswindow title='{{progresstitle}}' *ngIf="openedprogresslwindow"
            (close)="closeprogresslWindow()" [width]="500" [height]="200" [resizable]="false" [top]="100" [left]="200">
            <div><kendo-textarea [rows]="3" [textContent]="progressmessage" resizable="vertical" [readonly]="true"
                    [style.height.px]="50">
                </kendo-textarea>
            </div>
            <br><br>
            <kendo-progressbar [min]="min" [max]="max" [value]="progressValue" [label]="label"></kendo-progressbar>
        </kendo-window>
    </div>

    <kendo-dialog *ngIf="showRejectDialog" (close)="cancelRejection()">
        <kendo-dialog-titlebar>
            Enter Rejection Remark
        </kendo-dialog-titlebar>

        <div class="dialog-content">
            <textarea [(ngModel)]="rejectionRemark" rows="4" cols="40" [maxlength]="250" placeholder="Enter remark..."
                (ngModelChange)="onRemarkChange()"></textarea>
        </div>

        <kendo-dialog-actions>
            <button kendoButton class="allbuttons" (click)="submitRejection()" [disabled]="!isRemarkValid">OK</button>
            <button kendoButton class="allbuttons" (click)="cancelRejection()">Cancel</button>
        </kendo-dialog-actions>
    </kendo-dialog>

    <kendo-dialog *ngIf="showSubmittalsProp" (close)="closeSubmittalsPropPopup()" [width]="1000">
        <kendo-dialog-titlebar>
            Submittal Properties
        </kendo-dialog-titlebar>



        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
            <!-- Tabstrip header placeholder -->
            <div style="flex-grow: 1;">
                <!-- This is just a placeholder to align with tab headers -->
                <kendo-tabstrip [tabPosition]="'top'" style="visibility: hidden; height: 0;"></kendo-tabstrip>
            </div>

            <!-- Export Button -->
            <div>
                <button kendoButton class="allbuttons" (click)="exportToExcel($event)">Export</button>
            </div>
        </div>



        <kendo-tabstrip>
            <kendo-tabstrip-tab title="Submittal" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="card-container-file card scroll-fix" style="overflow-y: auto;">
                        <form style="display: flex;">
                            <table style="margin-bottom: 5px; margin-right: 10px;">
                                <!-- Upload ID in its own row -->
                                <tr>
                                    <td>Upload ID:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.uploadId"
                                            style="width: 150px;"></kendo-textbox>
                                    </td>
                                    <td style="width: 50px;"></td>
                                    <td>File Count:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.fileCount"
                                            style="width: 150px;"></kendo-textbox>
                                    </td>
                                </tr>

                                <!-- Two fields per row -->
                                <tr>
                                    <td>Status:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.status"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                    <td style="width: 50px;"></td>
                                    <td>Project:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="form.value.project.projectname"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                </tr>



                                <tr>
                                    <td>Order No.:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.objectName"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                    <td style="width: 50px;"></td>
                                    <td>Order Description:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.objectDescription"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                </tr>

                                <tr>
                                    <td>Transmittal:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.transmittal"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                    <td style="width: 50px;"></td>
                                    <td>Company:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.company"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                </tr>

                                <tr>
                                    <td>Submittal Date:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" 
                                        [value]="formatDateOrEmpty(selectedSubItem?.uploadDate)"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                    <td style="width: 50px;"></td>
                                    <td>Submitted By:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.uploadedBy"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                </tr>

                                <tr>
                                    <td>Acknowledged Date:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.ackDate"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                    <td style="width: 50px;"></td>
                                    <td>Acknowledged By:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.ackBy"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                </tr>

                                <tr>
                                    <td>Processed Date:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" 
                                        [value]="formatDateOrEmpty(selectedSubItem?.procDate)"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>
                                    <td style="width: 50px;"></td>
                                    <td>Processed By:</td>
                                    <td>
                                        <kendo-textbox [readonly]="true" [value]="selectedSubItem?.procBy"
                                            style="width: 200px;"></kendo-textbox>
                                    </td>

                                </tr>

                                <tr>
                                    <td>Remarks:</td>
                                    <td>


                                        <kendo-textbox [value]="selectedSubItem?.remarks" style="width: 200px;"
                                            [readonly]="true"></kendo-textbox>

                                        <!--<kendo-textarea [readonly]="true" [value]="selectedSubItem?.remarks" style="width: 200px;">
                                
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <div class="wrap-text">
                                    {{ selectedSubItem?.remarks }}
                                    </div>
                                </ng-template>
                            </kendo-textarea>-->
                                    </td>
                                    <td></td>
                                </tr>


                            </table>
                        </form>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab title="Files">
                <ng-template kendoTabContent>
                    <div>
                        <!-- Document content goes here -->
                        <kendo-grid #filegrid1 class="file-grid" [kendoGridBinding]="fileDataPopUp"
                            kendoGridSelectBy="file_id" [sortable]="true" [reorderable]="true" [resizable]="true"
                            [columnMenu]="{ filter: true }">

                            <kendo-grid-column field="file_id" title="File ID" [width]="100"></kendo-grid-column>
                            <kendo-grid-column field="filename" title="Filename" [width]="200"></kendo-grid-column>
                            <kendo-grid-column field="filesize_to_display" title="Filesize"
                                [width]="100"></kendo-grid-column>
                            <kendo-grid-column field="upload_date" title="File Upload Date" [width]="160">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    {{ dataItem.upload_date | date:'dd-MMM-yyyy' }}
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column field="uploaded_by" title="Uploaded By"
                                [width]="150"></kendo-grid-column>
                            <kendo-grid-column title="Handled Date" [width]="140">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    {{dataItem.processed?.split(' by ')[0]}}
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column title="Handled By" [width]="150">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    {{dataItem.processed?.split(' by ')[1]}}
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column title="Rejected Date" [width]="140">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    {{dataItem.rejected?.split(' by ')[0]}}
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column title="Rejected By" [width]="150">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    {{dataItem.rejected?.split(' by ')[1]}}
                                </ng-template>
                            </kendo-grid-column>


                            <!--<kendo-grid-column field="rejectedRemarks" title="Rejection Remarks" [width]="400">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div >
                                {{ dataItem.rejectedRemarks }}
                                </div>
                            </ng-template>
                        </kendo-grid-column>-->


                            <kendo-grid-column field="rejectedRemarks" title="Rejection Remarks" [width]="200">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <kendo-textbox [value]="dataItem.rejectedRemarks" [readonly]="true"
                                        style="background-color: transparent;"></kendo-textbox>
                                </ng-template>

                                <!--<ng-template kendoGridCellTemplate let-dataItem>
                                <textarea 
                                [value]="dataItem.rejectedRemarks" 
                                readonly 
                                style="width: 100%; height: auto; resize: none; overflow: auto; background-color: rgb(0 0 0 / 0%);
                                color: #333; font-weight: normal; font-family: Arial, sans-serif; border: none;">
                                </textarea>
                            </ng-template>-->
                            </kendo-grid-column>


                            <ng-template kendoGridNoRecordsTemplate>
                                <div style="background-color: rgb(215 212 212 / 20%);">

                                    <kendo-svgicon [icon]="svgIcon[0]" size="xxxlarge"></kendo-svgicon>

                                    <p>There is no data to display here.

                                    </p>
                                    <p>Make sure you select an upload in the grid above.</p>
                                </div>
                            </ng-template>
                        </kendo-grid>
                    </div>

                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>

        <kendo-dialog-actions>
            <div style="display: flex; justify-content: flex-end;">
                <button kendoButton class="allbuttons" style="width: 50px;"
                    (click)="closeSubmittalsPropPopup()">OK</button>
            </div>
        </kendo-dialog-actions>

    </kendo-dialog>

    <kendo-dialog *ngIf="showFilesProp" (close)="closeFilesPropPopup()" [width]="900" [height]="'auto'">
        <kendo-dialog-titlebar>
            File Properties
        </kendo-dialog-titlebar>


        <div class="dialog-content scroll-area">
            <div class="card-container-file card scroll-fix">
                <form style="display: flex;">
                    <table style="margin-bottom: 5px; margin-right: 10px;">
                        <tr>
                            <td>File ID:</td>
                            <td>
                                <kendo-textbox [readonly]="true" [value]="selectedFileItem?.file_id"
                                    style="width: 250px;"></kendo-textbox>
                            </td>
                        </tr>
                        <tr>
                            <td>Filename:</td>
                            <td>
                                <kendo-textbox [readonly]="true" [value]="selectedFileItem?.filename"
                                    style="width: 250px;"></kendo-textbox>
                            </td>
                            <td style="width: 50px;"></td>
                            <td style="padding-left: 10px;">Filesize:</td>
                            <td>
                                <kendo-textbox [readonly]="true" [value]="selectedFileItem?.filesize_to_display"
                                    style="width: 250px;"></kendo-textbox>
                            </td>

                        </tr>
                        <tr>
                            <td>Uploaded Date:</td>
                            <td>
                                <kendo-textbox [readonly]="true" [value]="selectedFileItem?.upload_date"
                                    style="width: 250px;"></kendo-textbox>
                            </td>
                            <td style="width: 50px;"></td>
                            <td style="padding-left: 10px;">Uploaded By:</td>
                            <td>
                                <kendo-textbox [readonly]="true" [value]="selectedFileItem?.uploaded_by"
                                    style="width: 250px;"></kendo-textbox>
                            </td>
                        </tr>
                        <tr>
                            <td>Handled Date:</td>
                            <td>
                                <kendo-textbox [readonly]="true"
                                    [value]="selectedFileItem?.processed? selectedFileItem.processed.split(' by ')[0] : ''"
                                    style="width: 250px;">
                                </kendo-textbox>
                            </td>
                            <td style="width: 50px;"></td>
                            <td style="padding-left: 10px;">Handled By:</td>
                            <td>
                                <kendo-textbox [readonly]="true"
                                    [value]="selectedFileItem?.processed? selectedFileItem.processed.split(' by ')[1] : ''"
                                    style="width: 250px;">
                                </kendo-textbox>
                            </td>
                        </tr>
                        <tr>
                            <td>Rejected Date:</td>
                            <td>
                                <kendo-textbox [readonly]="true"
                                    [value]="selectedFileItem?.rejected? selectedFileItem.rejected.split(' by ')[0] : ''"
                                    style="width: 250px;">
                                </kendo-textbox>
                            </td>
                            <td style="width: 50px;"></td>
                            <td style="padding-left: 10px;">Rejected By:</td>
                            <td>
                                <kendo-textbox [readonly]="true"
                                    [value]="selectedFileItem?.rejected ? selectedFileItem.rejected.split(' by ')[1] : ''"
                                    style="width: 250px;">
                                </kendo-textbox>
                            </td>
                        </tr>
                        <tr>

                            <td>Rejected Remark:</td>

                            <td>
                                <kendo-textarea [formControl]="rejectedRemarksControl"
                                    [readonly]="isReadOnly(selectedFileItem)" [rows]="2" [maxlength]="250"
                                    style="width: 100%; resize: vertical;"></kendo-textarea>
                            </td>

                            <!--<td>
                                <kendo-textbox   [formControl]="rejectedRemarksControl"
                                [readonly]="isReadOnly(selectedFileItem)" class="multiline-textbox"></kendo-textbox>
                            </td>-->
                            <td
                                *ngIf="accessType === 'PROCESS' &&  uploadObjStatus == 'Acknowledged' && selectedFileItem.status == 'Rejected'">
                                <button kendoButton title="Update Comment" class="allbuttons"
                                    (click)="updateRejectedRemark(selectedFileItem)" [svgIcon]="svgIcon[8]"></button>
                            </td>
                        </tr>

                    </table>
                </form>
            </div>
        </div>

        <kendo-dialog-actions>
            <div style="display: flex; justify-content: flex-end;">
                <button kendoButton class="allbuttons" style="width: 50px;" (click)="closeFilesPropPopup()">OK</button>
            </div>
        </kendo-dialog-actions>
    </kendo-dialog>





</div>
<ng-container kendoDialogContainer></ng-container>